import { memo, useContext } from 'react';
import { AppContext } from 'templates/AppContextProvider';

type LineAddFriendLinkProps = {
  href: string;
  alt: string;
};

export const LineAddFriendLink = memo((props: LineAddFriendLinkProps) => {
  const { currentLang } = useContext(AppContext);
  return (
    <a href={props.href} target="_blank" rel="noopener noreferrer">
      <img
        src={`https://scdn.line-apps.com/n/line_add_friends/btn/${currentLang}.png`}
        alt={props.alt}
        width={120}
        height={36}
      />
    </a>
  );
});
LineAddFriendLink.displayName = 'LineAddFriendLink';
